import dynamic from "next/dynamic";
 
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
 
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";
import { stateData } from "@/constants/electionConfig";
// import OldElectionScreen from "@/screens/OldStateElection";
const OldElectionScreen = dynamic(() => import("@/screens/OldStateElection"));

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  exitPollData = null,
  electionCategory,
}) {
  const isMobileDevice = useIsMobile();

  const state_data = stateData[electionCategory];

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <OldElectionScreen
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath="maharashtra-assembly/exit-poll"
          electionPath={`${electionCategory}/exit-poll-result`}
          isMobileDevice={isMobileDevice}
          masterKey={state_data?.masterConfigKey} //"delhi_election"
          electionPassedCategory={
            state_data?.["exit-poll-result"]?.electionPassedCategory
          } //'delhi-assembly'
          stateName={state_data?.["exit-poll-result"]?.state} //"Delhi"
          stateHindi={state_data?.["exit-poll-result"]?.stateHindi} //"महाराष्ट्र"
          metaData={state_data?.["exit-poll-result"]?.metaData}
          oldDesc={state_data?.["exit-poll-result"]?.exitDesc2019}
          newDesc={state_data?.["exit-poll-result"]?.exitDesc2024}
          exitPoll2019Data={state_data?.["exit-poll-result"]?.exit_2020}
          exitPoll2024Data={exitPollData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";
  let url = ctx?.resolvedUrl;
  url = url.split("/exit-poll-result")[0];
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");
 
  if(!stateData[electionCategory]){
    // console.log("stateData", stateData);
    return {
      notFound: true,
    };
  }
  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });
    // fetch api for exit poll  data
    const exitPollAPI = `https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json`;
    let exitPollData = [];
    await fetch(exitPollAPI,{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then(async (data) => {
      const data1 = await data.json();
      // console.log("exitpolldata", data1);
      exitPollData = data1?.find((item) => item?.agency == "AgencyDL");
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        exitPollData,
        electionCategory,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
